import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import Amplify, { Auth } from 'aws-amplify';

import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';

const httpLink = createHttpLink({
  uri: 'https://aod3tw4sezhlhptn6gzh2i2w5q.appsync-api.us-east-1.amazonaws.com/graphql'
});

const authLink = setContext((_, { headers }) => {
  return Auth.currentSession().then(session => {
    return {
      headers: {
        ...headers,
        authorization: session.idToken.jwtToken
      }
    }
  });
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

Amplify.configure({
  Auth: {
    identityPoolId: 'us-east-1:7518ba25-e377-49f2-bb71-6205656fa3ca',
    region: 'us-east-1',
    userPoolId: 'us-east-1_guTCF5klQ',
    userPoolWebClientId: 's1k4dsrim0bvqso00tm04oe9a',
    mandatorySignIn: true
  }
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js